import { takeEvery, put, delay } from 'redux-saga/effects';
import messageActions from './actions';
import { GLOBALS } from 'Constants';
import messageTypes from './types';

function* pushToasts(action) {
	const { payload } = action;
	const id = Date.now();

	yield put(
		messageActions.pushToast({
			id,
			type: action.type.split('_')[1].toLowerCase(),
			active: true,
			...payload,
		})
	);

	const toastTime = payload.toastTime || GLOBALS.TOAST_TIMEOUT.DEFAULT;
	if (toastTime !== GLOBALS.TOAST_TIMEOUT.UNSET) {
		yield delay(toastTime);
		yield put(messageActions.popToast(id));
	}
}

const messagesSagas = [
	takeEvery(
		[
			messageTypes.TOASTS.PUSH.SUCCESS,
			messageTypes.TOASTS.PUSH.ERROR,
			messageTypes.TOASTS.PUSH.WARNING,
			messageTypes.TOASTS.PUSH.INFO,
		],
		pushToasts
	),
];

export default messagesSagas;
